import { isInteractableLayer } from '@pn/core/domain/layer';
import {
  generatePatternLayerId,
  getPointsLayerId,
  getSelectedLayerId,
} from '@pn/core/domain/workspace';
import { customLayersRegistry } from '@pn/services/map/mapbox/custom/registry';
import { throwOnMapboxErrors } from '@pn/services/map/mapbox/mapboxUtils';
import type { MapboxIMap } from '..';

export const moveDataLayer: MapboxIMap['moveDataLayer'] = function (
  this: MapboxIMap,
  layer,
  getBeforeItemLayerId
) {
  if (!this.hasLayer(layer.id)) {
    throw new Error(`Layer ${layer.id} does not exist`);
  }

  throwOnMapboxErrors(this._native, `Failed to move layer ${layer.id}`, () => {
    const patternLayerId = generatePatternLayerId(layer.id);
    if (customLayersRegistry.has(patternLayerId)) {
      this._native.moveLayer(patternLayerId, getBeforeItemLayerId);
    }

    this._native.moveLayer(layer.id, getBeforeItemLayerId);

    if (isInteractableLayer(layer)) {
      this._native.moveLayer(
        getSelectedLayerId(layer.id),
        getBeforeItemLayerId
      );
    }

    if (layer.renderAsPoints) {
      this._native.moveLayer(getPointsLayerId(layer.id), getBeforeItemLayerId);

      if (isInteractableLayer(layer)) {
        this._native.moveLayer(
          getSelectedLayerId(getPointsLayerId(layer.id)),
          getBeforeItemLayerId
        );
      }
    }
  });
};
